import $ from "jquery";

let activeCollapse;

$('.locations [data-toggle=collapse]')
.on('click', function (e) {
  e.preventDefault();
  e.stopPropagation();
  
  var $this = $(this),
      $target = $($this.data('target') + '.collapse');

  if($('.locations .collapsing').length) return;

  if(!$target.length || activeCollapse === $target[0]) return;

  activeCollapse = $target[0];

  $target.collapse('show');

  return false;
});
